import { useNavigate } from "react-router-dom";

import MultipleChoiceQuestion from "../../../components/Questions/MultipleChoiceQuestion";
import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { questionContent } from "../questions";
import { shouldCheckDailyActivity } from "../DailyActivity/util";
import { CustomerSupportVulnerabilityCircumstanceFinancialInput } from "../../../generated/customer/schema.graphql";

// TODO: remove the Omit once the GraphQL is being updated. Requires some time to get advisers and customer to be on latest app.
type FinancialQuestion = Omit<
  Record<keyof CustomerSupportVulnerabilityCircumstanceFinancialInput, string>,
  "sufferingOrSufferedFromCovid19"
>;

export const financialQuestions: FinancialQuestion = {
  recentBereavement: "I've had a bereavement in the last 90 days",
  lostOrChangedJob: "I've lost my job in the last 3 months",
  inDebt: "I'm currently in debt",
  movedHome: "I've moved home in the last 3 months",
  isACarer: "I am a carer",
  receivingJobseekersAllowance:
    "I am receiving long-term Jobseeker's Allowance or Universal Credit",
};

const FinancialDetail: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (newAnswers: Record<string, boolean>) => {
    setAnswers({
      ...answers,
      financialDetail: newAnswers,
      ...(!newAnswers.recentBereavement
        ? {
            psr: undefined,
          }
        : {}),
    });
  };

  const onContinue = () => {
    if (shouldCheckDailyActivity(answers)) {
      navigate(`/${PATHS.About}/${ABOUT_ROUTES.DailyActivity}`);
    } else {
      navigate(`/${PATHS.Summary}`);
    }
  };

  return (
    <MultipleChoiceQuestion
      onChange={onChange}
      options={financialQuestions}
      values={answers.financialDetail}
      onContinue={onContinue}
      step={questionContent.financialDetail.step}
      title={questionContent.financialDetail.title}
      subTitle={questionContent.financialDetail.subTitle}
      whyWeWantTexts={questionContent.financialDetail.whyWeWantTextsCustomer}
      requireAnswer
    />
  );
};

export default FinancialDetail;
